<img
  class="sort-indicator"
  [matTooltipDisabled]="!isActive"
  [class.indicator-rotate]="isActive && sortDirection === 'desc'"
  src="../../../../assets/icons/product-date-sort.svg"
  [matTooltip]="sortDirection === 'asc' ? 'Ascending': 'Descending'"
>
